const settings = {
  genders: {
    man: "1",
    woman: "2",
    no_answer: "3",
  },
}

export default settings
